<template>
  <div v-if="data">
    <img
      v-if="data.is_superuser"
      src="../assets/instructionAdmin.jpg"
      alt=""
      srcset=""
      class="pic"
    />
    <img v-else src="../assets/instruction.jpg" alt="" srcset="" class="pic" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      data: null,
    };
  },
  mounted() {
    this.fetchUserDetail();
  },
  methods: {
    ...mapActions("user", ["getCurrentUserDetail", "logout"]),
    async fetchUserDetail() {
      const data = await this.getCurrentUserDetail();
      this.data = data;
    },
  },
};
</script>

<style scoped lang="scss">
.pic {
  width: 100%;
  height: 100%;
}
</style>
